<template>
  <div id="footer">
    <div class="container-fluid ">
      <div class="row">
        <div class="col-4 py-3"></div>
        <div class="col-4 py-3 text-center">
          <h5 class="mt-3">
            <span class="client-name">RM OF CHAPLIN</span>
            <span class="bar mx-1">|</span>
            <span class="copyright"
              >COPYRIGHT &copy; {{ new Date().getFullYear() }}</span
            >
          </h5>
        </div>
        <div class="col-4 py-3">
          <p class="text-right mt-3">
            <router-link to="/admin" tag="a" title="Login">
              <i class="fas fa-user"></i>
            </router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style lang="scss">
#footer {
  background-color: #333;
  color: #fff;

  a {
    color: #fff;

    transition: all 0.25s ease-in-out;

    &:hover,
    &:focus {
      color: #95b430;
    }
  }

  @media all and (max-width: 500px) {
    .client-name,
    .copyright {
      display: block;
      font-size: 0.75rem;
      margin: 0.5rem;
      text-align: center;
    }

    .bar {
      display: none;
    }
  }
}
</style>
